import get from 'lodash/get';

function parseQueryString() {
  const params = {};

  get(window, 'location.search', '').replace(
    new RegExp('([^?=&]+)(=([^&]*))?', 'g'), ($0, $1, $2, $3) => {
      params[decodeURIComponent($1)] = decodeURIComponent($3);
    },
  );

  return params;
}

export default parseQueryString;
